module.exports = __webpack_public_path__ + "static/assets/2343d0ec57b7450d26d6ba53f9bcb790.otf";